export function stripHtmlTags(input: string): string {
  return input.replace(/<[^>]*>/g, "");
}

export const LOGIN_SHAREHOLDER_SESSION_KEY = "login-shareholder";

/** 株主用ログイン画面からログインしたことを localStorage に保存する */
export function setLoginShareholderSession(): void {
  localStorage.setItem(LOGIN_SHAREHOLDER_SESSION_KEY, "1");
}

/** 株主用ログイン画面からログインしたか */
export function isLoginShareholderSession(): boolean {
  return localStorage.getItem(LOGIN_SHAREHOLDER_SESSION_KEY) === "1";
}

export function clearLoginShareholderSession(): void {
  localStorage.removeItem(LOGIN_SHAREHOLDER_SESSION_KEY);
}

const DEFAULT_LINE_BANNER_HIDDEN_GROUPS: readonly string[] = [
  "法人グループ8",
  "subscriber13",
  "subscriber10",
  "subscriber11",
  "subscriber12",
];

type LineBannerVisibilityParams = {
  lang: string;
  group: string;
  isLineLogin?: boolean;
};

/** LINEバナーを表示できる条件を判定する */
export function isVisibleLineBanner({
  lang,
  group,
  isLineLogin = false,
}: LineBannerVisibilityParams): boolean {
  return (
    lang === "ja" &&
    !isLineLogin &&
    !DEFAULT_LINE_BANNER_HIDDEN_GROUPS.includes(group)
  );
}

const ALIGNMENT_ALERT_GROUPS: readonly string[] = [
  "subscriber06",
  "subscriber07",
  "subscriber19",
];

/** トップのHomeAlignmentブロックを表示する対象グループか */
export function isVisibleHomeAlignment(group: string | null): boolean {
  if (!group) {
    return false;
  }
  const blackList = (process.env.VUE_APP_ALIGNMENT_BLACK_LIST || "").split(",");
  return !blackList.includes(group);
}

/** W連携周りの複数所属先ID注意表示を出す対象グループか */
export function isVisibleAlignmentAlert(group: string): boolean {
  return ALIGNMENT_ALERT_GROUPS.includes(group);
}

/** 初めてナビの遷移先URLを返す */
export function getBeginnerNaviUrl(group: string | null | undefined): string {
  if (!group) {
    return "/beginner-navi/";
  }
  const whiteList = (
    process.env.VUE_APP_SHOW_REWARDS_CLUB_BUTTON_WHITE_LIST || ""
  ).split(",");
  if (whiteList.includes(group)) {
    return "/beginner/";
  }
  return "/beginner-navi/";
}

export function showBeginnerNaviButton(group: string | null | undefined): boolean {
  if (!group) {
    return true;
  }
  const whiteList = (
    process.env.VUE_APP_SHOW_REWARDS_CLUB_BUTTON_WHITE_LIST || ""
  ).split(",");
  if (whiteList.includes(group)) {
    return false;
  }
  return true;
}

/** OPTIMA 予約のホテル詳細URL（/ja/hotels/）かどうか */
export function isOptimaHotelUrl(url: string): boolean {
  return url.startsWith(`${process.env.VUE_APP_OPTIMA_RESERVATION_URL}/ja/hotels/`);
}

/** 予約ボタンのリンクURLを返す */
export function hotelReserveLinkUrl(
  datas: { htl_id: string; stayingPlans: Array<{ buttonUrl: string }> },
  index: number,
  lang: string,
  authGroup: string,
  mghrwc: boolean
): string {
  const url = datas.stayingPlans[index].buttonUrl;
  if (authGroup === "subscriber12" && datas.htl_id === "tokyodome") {
    return lang === "en"
      ? "https://www.tokyodome-hotels.co.jp/e/stay/"
      : "https://www.tokyodome-hotels.co.jp/stay/plan/";
  }
  if (isOptimaHotelUrl(url) && mghrwc) {
    return `/to-mghrwc?redirect=${encodeURIComponent(url)}`;
  }
  return url;
}
